import router from '@/router'
import publics from '@/basic/publics'
import axios from 'axios'
let API_URL = publics.API_URL;
let ajax = function (newUrl, type, data, callback, route) {
    let p = new Promise((resolve, reject) => {
        let axiosUrl;
        let str;
        if (type == 'get') {
            str = API_URL + newUrl + (data ? '?' + data : '');
            axiosUrl = axios.get(str)
        } else if (type == 'delete') {
            str = API_URL + newUrl;
            axiosUrl = axios.delete(API_URL + newUrl, { data: data }, { headers: { 'Content-Type': 'application/json' } })
        } else if (type == 'post') {
            str = API_URL + newUrl;
            axiosUrl = axios.post(API_URL + newUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
        } else if (type == 'fileUpload') {
            str = API_URL + newUrl;
            axiosUrl = axios.post(API_URL + newUrl, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        }
        if (!axiosUrl) {
            publics.message.danger('系统出错');
            return false;
        }
        // console.log(str);
        // 1000 正常
        // 1011 参数错误
        // 1012 验证失败
        // 1013 用户无权限
        // 1014 用户登陆状态失效
        // 1050 数据库错误
        // 9999 操作失败
        axiosUrl.then(function (response) {
            // console.log(newUrl, str, response);
            let data = response.data;
            if (newUrl == 'reg' || newUrl == 'login' || newUrl == 'sms' || newUrl == 'pwd' || newUrl == 'logout') {
                if (data.code != "1000") {
                    console.log(data.error);
                    publics.message.danger(data.error);
                }
                callback(data)
                resolve()
            } else if (newUrl == 'account/parcel') {
                if (data.code == "1014" || data.code == "9999") {
                    if (route && route.name == 'register') {
                        // https://demo.dyuit.cn/yiyin/#/register?code=Z1Vugd
                    } else {
                        publics.message.danger(data.error);
                        // setTimeout(() => {
                        router.push({ name: 'login' });
                        // }, 1000)
                    }
                } else {
                    callback(data)
                    resolve()
                }
            } else if (newUrl == 'qr/invite') {
                callback(data)
                resolve()
            } else {
                if (data.code == "1000") {
                    callback(data)
                    resolve()
                } else if (data.code == "1014" || data.code == "9999") {
                    // publics.message.danger(data.error);
                    // console.log('111',router)
                    // console.log('222',route)
                    if (route && route.name == 'register') {
                        // https://demo.dyuit.cn/yiyin/#/register?code=Z1Vugd
                    } else {
                        publics.message.danger(data.error);
                        // setTimeout(() => {
                        router.push({ name: 'login' });
                        // }, 1000)
                    }
                } else {
                    publics.message.danger(data.error);
                }
            }
        })
            .catch(function (error) {
                // publics.message.danger(error);
            })
    })
}
export default ajax


// WEBPACK FOOTER //
// ./src/basic/ajax.js